/**
 * Blogs 小猪宰汁 
 * Date: 2023/3/2
 * filename：zh.js
 */
export const h = {
    KeywordTip: '请输入型号/产品信息',
    Keyword:'请输入型号或产品信息!',
    brand:'品牌',
    search_1:'厂家型号',
    search_2:'品牌',
    search_3:'批次',
    search_4:'封装',
    search_5:'描述',
    search_6:'阶梯价',
    search_7:'库存',
    search_8:'操作',
    search_9:'购买',
    contactEnter:"请输入",
    enterName:"请输入姓名",
    enterCompany:"请输入公司",
    enterPhone:"请输入电话",
    enterEmail:"请输入邮箱",
    enterContent:"请输入内容",
    subSccessful:"提交成功",
    home: "首页",
    aboutus: "关于我们",
    linecard: "品牌介绍",
    qualitycontrol: "质量管理",
    applications: "研发中心",
    contactus: "联系我们",
    introduction: "公司简介",
    aboutabracon: "关于ABRACON",
    joinus: "加入我们",
    seedetails: "查看详情",
    seemore:'查看更多',
    fl1_1:'公司简介',
    fl1_2:'加入我们',
    fl2_1:'Top 50 Lines',
    fl2_2:'推荐品牌',
    fl3_1:'实验室检验设备',
    fl3_2:'供应商分类与检验流程',
    fl3_3:'出库质量控制(OQC)流程',
    fl3_4:'仓储控制和管理',
    fl4_1:'产品应用',
    fl4_2:'知识产权',
    fr1_1:'+86 755 2643-3662',
    fr1_2:'sales@honengelec.com',
    b2l_1:'深圳',
    b2l_2:'上海',
    b2l_3:'香港',
    b2l_4:'苏州',
    b2l_5:'南京',
    b2l_6:'武汉',
    b2l_7:'河北',
    b2l_20:'天津',
    b2l_8:'厦门',
    b2l_9:'青岛',
    b2l_11:'新加坡',
    b2l_10:'粤ICP备20003977号',
    b2r_1:'隐私条款',
    b2r_2:'销售条款和条件',
    b2r_10:'全球贸易合规声明',
    t_1:'宏能知识产权统计表',
    t_2:'工业控制',
    t_3:'医疗电子',
    b_1:'汽车电子',
    b_3:'通讯',
    usc_1:'在线留言',
    usc_2:'姓名',
    usc_3:'公司',
    usc_4:'电话',
    usc_5:'邮箱',
    usc_6:'内容',
    usc_7:'提交',
    usc_8:'工作地点',
    usc_9:'地址',
    usc_10:'传真',
    abouts_1:"企业文化",
    abouts_2:"2020年会",
    abouts_3:"2019年会",
    abouts_4:"拓展活动",
    abouts_5:"2019重庆",
    abouts_6:"2018泰国",
    abouts_7:"2017云南",
    abouts_8:"优秀团队",
    abouts_9:'"源头追溯和技术手段是品质控制的根本，抓住行业的痛点，以满足客户的需求为己任，不断进行渠道优化和系统建设，借助互联网平台，致力打造一体化的服务体验"',
    join_1:'岗位职责',
    join_2:'职位要求',
    join_3:'有意者，请将简历发至Email',
  }